module.exports = __webpack_public_path__ + "d115470b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/home/products/custom.svg
// module id = 769
// module chunks = 2